<div class="registration-success">
    <img class="request-sent" src="../../../../content/images/registration/request-sent-illustration.svg"
         alt="Request sent" title="Request sent"/>
    <h1>Thank you for registering</h1>

    <div class="message">
        <h2>Your account was successfully created. Enjoy !</h2>
        You can now login with your account and start using Logbook or complete your personnal information.
    </div>

    <form [formGroup]="userForm" *ngIf="currentUser">
        <div class="registration-form">
            <div class="personal-information">
                <div class="title">
                    <span class="badge"><i class="icon-user"></i> </span>
                    Personal information
                    <span class="optional">(optional)</span>
                </div>

                <div class="inline-group">
                    <dln-input
                            label="First name"
                            type="text"
                            inputName="firstName"
                            [errorMessages]="{'required': 'Your firstname is required'}"
                            [required]="false"
                            [control]="firstName">
                    </dln-input>
                    <dln-input
                            label="Last name"
                            type="text"
                            inputName="lastName"
                            [errorMessages]="{'required': 'Your lastname is required'}"
                            [required]="false"
                            [control]="lastName">
                    </dln-input>
                </div>
                <div class="inline-group">
                    <dln-input
                            label="Position in company"
                            type="text"
                            inputName="position-in-company"
                            [errorMessages]="{'required': 'What do you do?'}"
                            [required]="false"
                            [control]="positionInCompany">
                    </dln-input>
                    <dln-input
                            label="Mobile phone (+33623456789)"
                            type="phone"
                            inputName="phone"
                            [required]="false"
                            [control]="phone">
                    </dln-input>
                </div>
                <div class="inline-group" *ngIf="!currentUser.company">
                    <!-- COMPANY -->
                    <dln-input
                        label="Ask for Company attachment"
                        type="custom"
                        [required]="false"
                        [control]="pendingCompany">
                        <dln-input-company id="pendingCompany"
                                           label="Ask for Company attachment"
                                           type="text"
                                           [required]="false"
                                           [formControl]="pendingCompany"
                                           [loggedUser]="currentUser">
                        </dln-input-company>
                    </dln-input>
                </div>
            </div>
            <div [ngClass]="{'submit-container': true, 'loading': loadingForm}">
                <dln-button type="submit" icon="icon-arrow-right" iconPosition="right"
                            color="white" border="black" label="Skip this step"
                            height="45px" (onClick)="goHome()">
                </dln-button>

                <span>OR</span>

                <dln-button [type]="'submit'" [isDisabled]="userForm.invalid"
                            [isLoading]="loadingForm" [isLoadingLabel]="'Sending request...'"
                            height="45px" (onClick)="save()"
                            [label]="'Send personal information'">
                </dln-button>


            </div>
            <div class="alert" *ngIf="error">
                {{error}}
            </div>
        </div>
    </form>
</div>




